// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Barlow-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Barlow-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Nelphim.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/Hero_BAAcademy.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Barlow";
  src: local("Barlow"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

@font-face {
  font-family: "BarlowBold";
  src: local("BarlowBold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

@font-face {
  font-family: "Nelphim";
  src: local("Nelphim"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}

@media only screen and (max-device-width: 768px) {
  .academy-wrapper {
    display: block;
    position: relative;
    padding-top: 30px;
    padding-bottom: 60px;
    height: 100%;
    width: 100%;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  .bg-image-academy {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 30% center;
    width: calc(100% - 120px);
    height: 60vh;
    margin-left: 60px;
    border-radius: 20px;
  }

  .academy-hero-col {
    display: inline-block;
    grid-template-columns: auto;
    gap: 10px;
    height: 100%;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  .academy-hero-bg-col-1 {
    padding: 60px 0px 0px 30px;
    margin-bottom: 0%;
    animation: fadeIn 5s;
  }

  .academy-hero-bg-col-1 .header-title-left {
    font-family: "Nelphim";
    font-size: 4.5em;
    color: white;
  }

  .academy-hero-bg-col-2 {
    top: 35%;
    padding: 0px 0px 0px 30px;
  }

  .academy-hero-bg-col-2 .header-title-right {
    font-family: "Nelphim";
    font-size: 4.5em;
    color: white;
  }

  .academy-btn-hero-group {
    position: absolute;
    margin-left: 30px;
    margin-top: -20%;
    left: 60px;
    display: flex;
    align-items: center;
  }

  .wwr-img .wwr-img-group {
    gap: 16px;
  }

  .wwr-img .wwr-img-group img {
    border-radius: 20px;
  }

  .section-empower-1 {
    padding: 30px;
    width: 65%;
  }

  .section-empower-2 {
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    padding: 30px 30px 45px 30px;
  }

  .empower-box {
    padding: 24px;
    border-radius: 20px;
  }

  .reape-header-image-group {
    width: calc(100% - 90px);
    padding-left: 30px;
    padding-bottom: 30px;
  }

  .reape-header-image-group .reape-image {
    border-radius: 20px;
  }

  .reape-ba-image-group {
    padding-top: 30px;
  }

  .reape-ba-image-group .reape-ba-image {
    border-radius: 20px;
  }

  .reape-ba-detail-web .section-detail-large {
    padding-top: 60px;
  }

  .ba-news-card {
    gap: 16px;
  }

  .ba-news-detail-group {
    border-radius: 20px;
  }

  .ba-news-inner-detail {
    width: 65%;
    padding: 16px 16px 0px 16px;
  }

  .ba-news-inner-detail .detail-flex {
    margin-bottom: 16px;
  }

  .ba-news-image-group {
    width: 35%;
    padding: 16px 16px 16px 0px;
  }
}

@media only screen and (max-device-width: 480px) {
  .academy-wrapper {
    display: block;
    position: relative;
    padding-top: 15px;
    padding-bottom: 30px;
    height: 100%;
    width: 100%;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  .bg-image-academy {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 40% center;
    width: calc(100% - 60px);
    height: calc(100vh - 80px - 45px);
    margin-left: 30px;
    border-radius: 20px;
  }

  .academy-hero-col {
    display: inline-block;
    grid-template-columns: auto;
    gap: 10px;
    height: 100%;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  .academy-hero-bg-col-1 {
    padding: 60px 0px 0px 30px;
    margin-bottom: 0%;
    animation: fadeIn 5s;
  }

  .academy-hero-bg-col-1 .header-title-left {
    font-family: "Nelphim";
    font-size: 3.5em;
    color: white;
  }

  .academy-hero-bg-col-2 {
    top: 35%;
    padding: 0px 0px 0px 30px;
    right: unset;
    text-align: left;
    animation: fadeIn 5s;
  }

  .academy-hero-bg-col-2 .header-title-right {
    font-family: "Nelphim";
    font-size: 3.5em;
    color: white;
  }

  .academy-btn-hero-group {
    position: absolute;
    margin-left: 0px;
    margin-top: -20%;
    left: 60px;
    display: flex;
    align-items: center;
  }

  .section-wwr-header {
    display: block;
    max-width: 1366px;
    padding: 0px 0px 30px 0px;
    margin-left: auto;
    margin-right: auto;
    overflow: auto;
  }

  .wwr-header-text {
    width: 100%;
    display: block;
  }

  .wwr-header-text .section-item-1 {
    width: calc(100% - 60px);
    padding: 30px 30px 30px 30px;
  }

  .wwr-header-text .section-item-2 {
    width: calc(100% - 60px);
    padding: 0px 30px;
  }

  .wwr-header-image-group {
    display: block;
    max-width: 1366px;
    padding: 0px 0px;
    margin-left: auto;
    margin-right: auto;
  }

  .wwr-img {
    width: calc(100% - 60px);
    display: block;
    padding: 0px 30px 0px 30px;
    overflow: auto;
  }

  .wwr-img .wwr-img-group {
    width: 100%;
    display: block;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    overflow: auto;
  }

  .wwr-img .wwr-img-group img {
    width: 100%;
    border-radius: 10px;
    margin-bottom: 12px;
  }

  .section-empower {
    display: block;
    max-width: 1366px;
    padding: 0px;
    margin-left: auto;
    margin-right: auto;
  }

  .section-empower .section-empower-group {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .section-empower .empower-bg-image {
    background: unset;
    background-color: #ecebe6;
    background-size: unset;
    /* <------ */
    background-repeat: unset;
    background-position: unset;
    width: 100%;
    height: unset;
    border-radius: 0px;
    position: relative;
  }

  .section-empower-1 {
    padding: 60px 30px 30px 30px;
    width: calc(100% - 60px);
  }

  .empower-img-group-mobile {
    display: block;
    width: 100%;
    position: relative;
  }

  .empower-img {
    width: 100%;
    mask-image: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0) 5%,
      rgba(0, 0, 0, 0.9) 20%,
      rgba(0, 0, 0, 1) 50%,
      rgba(0, 0, 0, 0.9) 80%,
      rgba(0, 0, 0, 0) 95%
    );
  }

  .section-empower-2 {
    display: block;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 24px;
    padding: 30px 30px 45px 30px;
    position: relative;
    bottom: 0px;
  }

  .empower-box {
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 16px;
    border: 1px solid #ecebe6;
    background: rgba(252, 252, 252, 0.2);
    /* Glassy Card */
    box-shadow: 0px 119px 33px 0px rgba(135, 135, 135, 0),
      0px 76px 31px 0px rgba(135, 135, 135, 0.01),
      0px 43px 26px 0px rgba(135, 135, 135, 0.02),
      0px 19px 19px 0px rgba(135, 135, 135, 0.04),
      0px 5px 10px 0px rgba(135, 135, 135, 0.04);
    backdrop-filter: blur(10px);
  }

  .empower-box .section-detail-large {
    padding-bottom: 12px;
  }

  .empower-box .section-detail-small {
    text-align: justify;
  }

  .business-associate-wrapper {
    display: block;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    overflow: auto;
    padding-bottom: 60px;
    padding-top: 60px;
  }

  .section-reape-success {
    display: block;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    overflow: auto;
    padding-bottom: 60px;
    padding-top: 60px;
  }

  .reape-grid {
    display: block;
    grid-template-columns: 40% 60%;
    grid-template-rows: 2fr;
    width: 100%;
    overflow: auto;
  }

  .business-associate-header {
    width: calc(100% - 60px);
    display: flex;
    align-items: center;
    padding-right: 30px;
    padding-left: 30px;
    padding-bottom: 30px;
  }

  .reape-success-header-text {
    width: calc(100% - 60px);
    display: flex;
    align-items: center;
    padding-right: 30px;
    padding-left: 30px;
    padding-bottom: 30px;
  }

  .reape-header-image-group {
    width: calc(100% - 60px);
    position: relative;
    margin-left: auto;
    margin-right: auto;
    padding: unset;
  }

  .reape-header-image-group .reape-image {
    display: block;
    width: 100%;
    border-radius: 10px;
  }

  .reape-ba-image-group {
    width: calc(100% - 60px);
    position: relative;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding: unset;
  }

  .reape-ba-image-group .reape-ba-image {
    display: block;
    width: 100%;
    border-radius: 10px;
  }

  .reape-ba-detail-mobile {
    display: block;
    width: calc(100% - 60px);
    margin-left: auto;
    margin-right: auto;
    padding-top: 60px;
    padding-bottom: 30px;
    text-align: justify;
  }

  .reape-ba-detail-mobile .section-detail-large {
    padding-top: 16px;
  }

  .reape-ba-detail-web {
    display: none;
  }

  .section-ba-news {
    display: block;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    overflow: auto;
    padding-bottom: 60px;
    padding-top: 60px;
  }

  .ba-news-header {
    display: inline-flex;
    padding-left: 30px;
    padding-right: 30px;
    width: calc(100% - 60px);
    justify-content: space-between;
    align-items: flex-end;
    padding-bottom: 30px;
  }

  .ba-news-header .section-item-2 {
    display: inline-flex;
    gap: 10px;
  }

  .content-slider {
    display: block;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    overflow: auto;
  }

  .ba-news-content {
    display: block;
    width: calc(100% - 60px);
    margin-left: auto;
    margin-right: auto;
  }

  .section-business-associate-content {
    display: block;
    width: calc(100% - 60px);
    margin-left: auto;
    margin-right: auto;
  }

  .ba-news-card {
    display: flex;
    width: 100%;
    gap: 24px;
    overflow-x: hidden;
    scroll-behavior: smooth;
    overflow-y: hidden;
  }

  .ba-news-detail-group {
    width: 100%;
    min-width: 100%;
    background-color: #f7f7f7;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
  }

  .ba-news-detail-group .ba-news-image {
    border-radius: 10px;
  }

  .ba-news-inner {
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: row-reverse;
    padding: 12px;
    overflow: auto;
  }

  .ba-news-inner-detail {
    width: 55%;
    padding: 0px;
    line-height: 1.5;
    padding-left: 16px;
  }

  .ba-news-inner-detail .detail-flex {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
  }

  .ba-news-image-group {
    width: 45%;
    padding: 0px;
  }

  .ba-news-image-group .ba-news-image {
    width: 100%;
  }

  button.left-arrow {
    height: fit-content;
    display: block;
    border-radius: 10px;
    border: 1px solid #7ba7c2;
    background: #eee;
    backdrop-filter: blur(10px);
    cursor: pointer;
    display: flex;
    padding: 10px;
    justify-content: center;
    align-items: center;
    color: #7ba7c2;
  }

  button.left-arrow:hover {
    display: block;
    border-radius: 10px;
    border: 1px solid #7ba7c2;
    background: #7ba7c2;
    backdrop-filter: blur(10px);
    cursor: pointer;
    display: flex;
    padding: 10px;
    justify-content: center;
    align-items: center;
    color: #fcfcfc;
  }

  button.right-arrow {
    height: fit-content;
    border-radius: 10px;
    border: 1px solid #7ba7c2;
    background: #eee;
    backdrop-filter: blur(10px);
    cursor: pointer;
    display: flex;
    padding: 10px;
    justify-content: center;
    align-items: center;
    color: #7ba7c2;
  }

  button.right-arrow:hover {
    display: block;
    border-radius: 10px;
    border: 1px solid #7ba7c2;
    background: #7ba7c2;
    backdrop-filter: blur(10px);
    cursor: pointer;
    display: flex;
    padding: 10px;
    justify-content: center;
    align-items: center;
    color: #fcfcfc;
  }

  .section-faq {
    display: block;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    overflow: auto;
    padding-bottom: 0px;
  }

  .section-faq-container {
    display: block;
    padding: 60px 30px;
    width: calc(100% - 60px);
    grid-template-columns: 40% 60%;
    grid-template-rows: 1fr;
    overflow: auto;
  }

  .faq-content {
    padding-top: 30px;
  }
  .business-associate-content {
    display: block;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: auto;
    text-align: center;
    padding: 0px 30px;
  }
  .business-associate-content-inner {
    display: block;
  }
  .business-associate-content-inner .business-associate-card {
    width: 100%;
    display: inline-grid;
    text-align: left;
    position: relative;
  }

  .business-associate-content-inner
    .business-associate-card
    .business-associate-img-box {
    border-radius: 30px;
    width: 100%;
    background: #d3d1c5;
    display: inline-block;
    position: relative;
    overflow: hidden;
    margin-top: 20px;
  }
  .business-associate-content-inner
    .business-associate-card
    .business-associate-img-box
    .business-associate-img {
    width: 100%;
  }
  .business-associate-content-inner
    .business-associate-card
    .business-associate-title-group {
    padding: 16px 0px 0px 0px;
    display: flex;
    flex-direction: column-reverse;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/academy_mobile.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,4EAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,gFAA2E;AAC7E;;AAEA;EACE,sBAAsB;EACtB,8EAAoE;AACtE;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mDAAgD;IAChD,sBAAsB;IACtB,4BAA4B;IAC5B,+BAA+B;IAC/B,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;IAC3B,SAAS;IACT,YAAY;EACd;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,8BAA8B;IAC9B,SAAS;IACT,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mDAAgD;IAChD,sBAAsB;IACtB,4BAA4B;IAC5B,+BAA+B;IAC/B,wBAAwB;IACxB,iCAAiC;IACjC,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,2BAA2B;IAC3B,SAAS;IACT,YAAY;EACd;;EAEA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,cAAc;IACd,0BAA0B;IAC1B,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,8BAA8B;IAC9B,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,wBAAwB;IACxB,0BAA0B;IAC1B,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;IAC5B,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX;;;;;;;KAOC;EACH;;EAEA;IACE,cAAc;IACd,sCAAsC;IACtC,SAAS;IACT,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;IACpC,gBAAgB;IAChB;;;;gDAI4C;IAC5C,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,8BAA8B;IAC9B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;;IAGE,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;;;;IAIE,WAAW;EACb;EACA;;;IAGE,yBAAyB;IACzB,aAAa;IACb,8BAA8B;EAChC;AACF","sourcesContent":["@font-face {\n  font-family: \"Barlow\";\n  src: local(\"Barlow\"), url(\"../fonts/Barlow-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"BarlowBold\";\n  src: local(\"BarlowBold\"), url(\"../fonts/Barlow-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Nelphim\";\n  src: local(\"Nelphim\"), url(\"../fonts/Nelphim.woff2\") format(\"woff2\");\n}\n\n@media only screen and (max-device-width: 768px) {\n  .academy-wrapper {\n    display: block;\n    position: relative;\n    padding-top: 30px;\n    padding-bottom: 60px;\n    height: 100%;\n    width: 100%;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n  }\n\n  .bg-image-academy {\n    background: url(\"../images/Hero_BAAcademy.webp\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: 30% center;\n    width: calc(100% - 120px);\n    height: 60vh;\n    margin-left: 60px;\n    border-radius: 20px;\n  }\n\n  .academy-hero-col {\n    display: inline-block;\n    grid-template-columns: auto;\n    gap: 10px;\n    height: 100%;\n  }\n\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n\n    100% {\n      opacity: 1;\n    }\n  }\n\n  .academy-hero-bg-col-1 {\n    padding: 60px 0px 0px 30px;\n    margin-bottom: 0%;\n    animation: fadeIn 5s;\n  }\n\n  .academy-hero-bg-col-1 .header-title-left {\n    font-family: \"Nelphim\";\n    font-size: 4.5em;\n    color: white;\n  }\n\n  .academy-hero-bg-col-2 {\n    top: 35%;\n    padding: 0px 0px 0px 30px;\n  }\n\n  .academy-hero-bg-col-2 .header-title-right {\n    font-family: \"Nelphim\";\n    font-size: 4.5em;\n    color: white;\n  }\n\n  .academy-btn-hero-group {\n    position: absolute;\n    margin-left: 30px;\n    margin-top: -20%;\n    left: 60px;\n    display: flex;\n    align-items: center;\n  }\n\n  .wwr-img .wwr-img-group {\n    gap: 16px;\n  }\n\n  .wwr-img .wwr-img-group img {\n    border-radius: 20px;\n  }\n\n  .section-empower-1 {\n    padding: 30px;\n    width: 65%;\n  }\n\n  .section-empower-2 {\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    padding: 30px 30px 45px 30px;\n  }\n\n  .empower-box {\n    padding: 24px;\n    border-radius: 20px;\n  }\n\n  .reape-header-image-group {\n    width: calc(100% - 90px);\n    padding-left: 30px;\n    padding-bottom: 30px;\n  }\n\n  .reape-header-image-group .reape-image {\n    border-radius: 20px;\n  }\n\n  .reape-ba-image-group {\n    padding-top: 30px;\n  }\n\n  .reape-ba-image-group .reape-ba-image {\n    border-radius: 20px;\n  }\n\n  .reape-ba-detail-web .section-detail-large {\n    padding-top: 60px;\n  }\n\n  .ba-news-card {\n    gap: 16px;\n  }\n\n  .ba-news-detail-group {\n    border-radius: 20px;\n  }\n\n  .ba-news-inner-detail {\n    width: 65%;\n    padding: 16px 16px 0px 16px;\n  }\n\n  .ba-news-inner-detail .detail-flex {\n    margin-bottom: 16px;\n  }\n\n  .ba-news-image-group {\n    width: 35%;\n    padding: 16px 16px 16px 0px;\n  }\n}\n\n@media only screen and (max-device-width: 480px) {\n  .academy-wrapper {\n    display: block;\n    position: relative;\n    padding-top: 15px;\n    padding-bottom: 30px;\n    height: 100%;\n    width: 100%;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n  }\n\n  .bg-image-academy {\n    background: url(\"../images/Hero_BAAcademy.webp\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: 40% center;\n    width: calc(100% - 60px);\n    height: calc(100vh - 80px - 45px);\n    margin-left: 30px;\n    border-radius: 20px;\n  }\n\n  .academy-hero-col {\n    display: inline-block;\n    grid-template-columns: auto;\n    gap: 10px;\n    height: 100%;\n  }\n\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n\n    100% {\n      opacity: 1;\n    }\n  }\n\n  .academy-hero-bg-col-1 {\n    padding: 60px 0px 0px 30px;\n    margin-bottom: 0%;\n    animation: fadeIn 5s;\n  }\n\n  .academy-hero-bg-col-1 .header-title-left {\n    font-family: \"Nelphim\";\n    font-size: 3.5em;\n    color: white;\n  }\n\n  .academy-hero-bg-col-2 {\n    top: 35%;\n    padding: 0px 0px 0px 30px;\n    right: unset;\n    text-align: left;\n    animation: fadeIn 5s;\n  }\n\n  .academy-hero-bg-col-2 .header-title-right {\n    font-family: \"Nelphim\";\n    font-size: 3.5em;\n    color: white;\n  }\n\n  .academy-btn-hero-group {\n    position: absolute;\n    margin-left: 0px;\n    margin-top: -20%;\n    left: 60px;\n    display: flex;\n    align-items: center;\n  }\n\n  .section-wwr-header {\n    display: block;\n    max-width: 1366px;\n    padding: 0px 0px 30px 0px;\n    margin-left: auto;\n    margin-right: auto;\n    overflow: auto;\n  }\n\n  .wwr-header-text {\n    width: 100%;\n    display: block;\n  }\n\n  .wwr-header-text .section-item-1 {\n    width: calc(100% - 60px);\n    padding: 30px 30px 30px 30px;\n  }\n\n  .wwr-header-text .section-item-2 {\n    width: calc(100% - 60px);\n    padding: 0px 30px;\n  }\n\n  .wwr-header-image-group {\n    display: block;\n    max-width: 1366px;\n    padding: 0px 0px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .wwr-img {\n    width: calc(100% - 60px);\n    display: block;\n    padding: 0px 30px 0px 30px;\n    overflow: auto;\n  }\n\n  .wwr-img .wwr-img-group {\n    width: 100%;\n    display: block;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    overflow: auto;\n  }\n\n  .wwr-img .wwr-img-group img {\n    width: 100%;\n    border-radius: 10px;\n    margin-bottom: 12px;\n  }\n\n  .section-empower {\n    display: block;\n    max-width: 1366px;\n    padding: 0px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .section-empower .section-empower-group {\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .section-empower .empower-bg-image {\n    background: unset;\n    background-color: #ecebe6;\n    background-size: unset;\n    /* <------ */\n    background-repeat: unset;\n    background-position: unset;\n    width: 100%;\n    height: unset;\n    border-radius: 0px;\n    position: relative;\n  }\n\n  .section-empower-1 {\n    padding: 60px 30px 30px 30px;\n    width: calc(100% - 60px);\n  }\n\n  .empower-img-group-mobile {\n    display: block;\n    width: 100%;\n    position: relative;\n  }\n\n  .empower-img {\n    width: 100%;\n    mask-image: linear-gradient(\n      90deg,\n      rgba(0, 0, 0, 0) 5%,\n      rgba(0, 0, 0, 0.9) 20%,\n      rgba(0, 0, 0, 1) 50%,\n      rgba(0, 0, 0, 0.9) 80%,\n      rgba(0, 0, 0, 0) 95%\n    );\n  }\n\n  .section-empower-2 {\n    display: block;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    gap: 24px;\n    padding: 30px 30px 45px 30px;\n    position: relative;\n    bottom: 0px;\n  }\n\n  .empower-box {\n    padding: 20px;\n    border-radius: 10px;\n    margin-bottom: 16px;\n    border: 1px solid #ecebe6;\n    background: rgba(252, 252, 252, 0.2);\n    /* Glassy Card */\n    box-shadow: 0px 119px 33px 0px rgba(135, 135, 135, 0),\n      0px 76px 31px 0px rgba(135, 135, 135, 0.01),\n      0px 43px 26px 0px rgba(135, 135, 135, 0.02),\n      0px 19px 19px 0px rgba(135, 135, 135, 0.04),\n      0px 5px 10px 0px rgba(135, 135, 135, 0.04);\n    backdrop-filter: blur(10px);\n  }\n\n  .empower-box .section-detail-large {\n    padding-bottom: 12px;\n  }\n\n  .empower-box .section-detail-small {\n    text-align: justify;\n  }\n\n  .business-associate-wrapper {\n    display: block;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    overflow: auto;\n    padding-bottom: 60px;\n    padding-top: 60px;\n  }\n\n  .section-reape-success {\n    display: block;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    overflow: auto;\n    padding-bottom: 60px;\n    padding-top: 60px;\n  }\n\n  .reape-grid {\n    display: block;\n    grid-template-columns: 40% 60%;\n    grid-template-rows: 2fr;\n    width: 100%;\n    overflow: auto;\n  }\n\n  .business-associate-header {\n    width: calc(100% - 60px);\n    display: flex;\n    align-items: center;\n    padding-right: 30px;\n    padding-left: 30px;\n    padding-bottom: 30px;\n  }\n\n  .reape-success-header-text {\n    width: calc(100% - 60px);\n    display: flex;\n    align-items: center;\n    padding-right: 30px;\n    padding-left: 30px;\n    padding-bottom: 30px;\n  }\n\n  .reape-header-image-group {\n    width: calc(100% - 60px);\n    position: relative;\n    margin-left: auto;\n    margin-right: auto;\n    padding: unset;\n  }\n\n  .reape-header-image-group .reape-image {\n    display: block;\n    width: 100%;\n    border-radius: 10px;\n  }\n\n  .reape-ba-image-group {\n    width: calc(100% - 60px);\n    position: relative;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    padding: unset;\n  }\n\n  .reape-ba-image-group .reape-ba-image {\n    display: block;\n    width: 100%;\n    border-radius: 10px;\n  }\n\n  .reape-ba-detail-mobile {\n    display: block;\n    width: calc(100% - 60px);\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 60px;\n    padding-bottom: 30px;\n    text-align: justify;\n  }\n\n  .reape-ba-detail-mobile .section-detail-large {\n    padding-top: 16px;\n  }\n\n  .reape-ba-detail-web {\n    display: none;\n  }\n\n  .section-ba-news {\n    display: block;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    overflow: auto;\n    padding-bottom: 60px;\n    padding-top: 60px;\n  }\n\n  .ba-news-header {\n    display: inline-flex;\n    padding-left: 30px;\n    padding-right: 30px;\n    width: calc(100% - 60px);\n    justify-content: space-between;\n    align-items: flex-end;\n    padding-bottom: 30px;\n  }\n\n  .ba-news-header .section-item-2 {\n    display: inline-flex;\n    gap: 10px;\n  }\n\n  .content-slider {\n    display: block;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    overflow: auto;\n  }\n\n  .ba-news-content {\n    display: block;\n    width: calc(100% - 60px);\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .section-business-associate-content {\n    display: block;\n    width: calc(100% - 60px);\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .ba-news-card {\n    display: flex;\n    width: 100%;\n    gap: 24px;\n    overflow-x: hidden;\n    scroll-behavior: smooth;\n    overflow-y: hidden;\n  }\n\n  .ba-news-detail-group {\n    width: 100%;\n    min-width: 100%;\n    background-color: #f7f7f7;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n  }\n\n  .ba-news-detail-group .ba-news-image {\n    border-radius: 10px;\n  }\n\n  .ba-news-inner {\n    width: 100%;\n    display: flex;\n    align-items: flex-start;\n    flex-direction: row-reverse;\n    padding: 12px;\n    overflow: auto;\n  }\n\n  .ba-news-inner-detail {\n    width: 55%;\n    padding: 0px;\n    line-height: 1.5;\n    padding-left: 16px;\n  }\n\n  .ba-news-inner-detail .detail-flex {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 30px;\n  }\n\n  .ba-news-image-group {\n    width: 45%;\n    padding: 0px;\n  }\n\n  .ba-news-image-group .ba-news-image {\n    width: 100%;\n  }\n\n  button.left-arrow {\n    height: fit-content;\n    display: block;\n    border-radius: 10px;\n    border: 1px solid #7ba7c2;\n    background: #eee;\n    backdrop-filter: blur(10px);\n    cursor: pointer;\n    display: flex;\n    padding: 10px;\n    justify-content: center;\n    align-items: center;\n    color: #7ba7c2;\n  }\n\n  button.left-arrow:hover {\n    display: block;\n    border-radius: 10px;\n    border: 1px solid #7ba7c2;\n    background: #7ba7c2;\n    backdrop-filter: blur(10px);\n    cursor: pointer;\n    display: flex;\n    padding: 10px;\n    justify-content: center;\n    align-items: center;\n    color: #fcfcfc;\n  }\n\n  button.right-arrow {\n    height: fit-content;\n    border-radius: 10px;\n    border: 1px solid #7ba7c2;\n    background: #eee;\n    backdrop-filter: blur(10px);\n    cursor: pointer;\n    display: flex;\n    padding: 10px;\n    justify-content: center;\n    align-items: center;\n    color: #7ba7c2;\n  }\n\n  button.right-arrow:hover {\n    display: block;\n    border-radius: 10px;\n    border: 1px solid #7ba7c2;\n    background: #7ba7c2;\n    backdrop-filter: blur(10px);\n    cursor: pointer;\n    display: flex;\n    padding: 10px;\n    justify-content: center;\n    align-items: center;\n    color: #fcfcfc;\n  }\n\n  .section-faq {\n    display: block;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    overflow: auto;\n    padding-bottom: 0px;\n  }\n\n  .section-faq-container {\n    display: block;\n    padding: 60px 30px;\n    width: calc(100% - 60px);\n    grid-template-columns: 40% 60%;\n    grid-template-rows: 1fr;\n    overflow: auto;\n  }\n\n  .faq-content {\n    padding-top: 30px;\n  }\n  .business-associate-content {\n    display: block;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    overflow: auto;\n    text-align: center;\n    padding: 0px 30px;\n  }\n  .business-associate-content-inner {\n    display: block;\n  }\n  .business-associate-content-inner .business-associate-card {\n    width: 100%;\n    display: inline-grid;\n    text-align: left;\n    position: relative;\n  }\n\n  .business-associate-content-inner\n    .business-associate-card\n    .business-associate-img-box {\n    border-radius: 30px;\n    width: 100%;\n    background: #d3d1c5;\n    display: inline-block;\n    position: relative;\n    overflow: hidden;\n    margin-top: 20px;\n  }\n  .business-associate-content-inner\n    .business-associate-card\n    .business-associate-img-box\n    .business-associate-img {\n    width: 100%;\n  }\n  .business-associate-content-inner\n    .business-associate-card\n    .business-associate-title-group {\n    padding: 16px 0px 0px 0px;\n    display: flex;\n    flex-direction: column-reverse;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
